export const LABEL_TEXT = 'Purpose Statement'
